import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=782f4555"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports